// No HTTP routes for this module
// All functionality is exposed via GraphQL resolvers

export default []
